import styled from 'styled-components';
import { nonStaticNavbarWithAndPaddingCss } from '@dbh/navbar';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import '@dbh/styled-helpers';
import media from '@dbh/media-queries';

const CardContainer=/*#__PURE__*/styled.div.withConfig({componentId:"sc-qkbbsm-0"})(["",""],nonStaticNavbarWithAndPaddingCss);CardContainer.displayName="CardContainer";var CardContainer$1 = CardContainer;

var _templateObject;const CardWrapper=/*#__PURE__*/styled.div.withConfig({componentId:"sc-br6mry-0"})(["width:100%;background:#FFFFFF;box-shadow:0px 1px 6px #BEBEBE;padding:1.6rem 1.6rem 2rem;margin-bottom:2.4rem;",";"],media.md(_templateObject||(_templateObject=_taggedTemplateLiteralLoose(["\n    width: ",";\n  "])),()=>"calc(44rem + 26rem)"));CardWrapper.displayName="CardWrapper";var CardWrapper$1 = CardWrapper;

export { CardContainer$1 as C, CardWrapper$1 as a };
